/* src/app/components/leads/participant-information/parent-guardian/parent-guardian.component.css */
.pg-row {
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 12px;
}
.pg-row:last-of-type {
  border-bottom: none;
}
.pg-row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.pg-row-header .sub-header {
  margin: 0;
}
.pg-na {
  display: inline-block;
  margin: 8px 0;
}
.add-btn {
  margin-top: 8px;
}
.pg-read-block {
  margin-bottom: 12px;
}
.required {
  color: #c00;
}
::ng-deep .pg-edit .ppl-form-label,
::ng-deep .pg-edit .ppl-form-label label {
  font-weight: 600;
}
::ng-deep ppl-address .address-field-wrapper {
  width: 100%;
}
::ng-deep ppl-address .address-field-wrapper .ant-select {
  flex: 1 1 auto;
  width: 100%;
}
/*# sourceMappingURL=parent-guardian.component-ZD6IOQIW.css.map */
